import { SuspenseErrorBoundary } from '@/components/SuspenseErrorBoundary';
import { GetInvoiceReportSummaryResponse } from 'ap-openapi';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import { LeftContent } from './LeftContent';
import { RightContent } from './RightContent';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

type InvoiceReportDetailProps = {
  summaryData?: GetInvoiceReportSummaryResponse;
  isLoading: boolean;
  reportId: string;
  /** Whether the office is duty-free, used to exclude tax-related columns from the transactions table */
  isDutyFree: boolean;
};

const InnerDetail: FC<InvoiceReportDetailProps> = ({
  summaryData,
  isLoading,
  reportId,
  isDutyFree,
}) => {
  return (
    <div className={cx('detail')}>
      <LeftContent
        data={summaryData}
        isLoading={isLoading}
        reportId={reportId}
        isDutyFree={isDutyFree}
      />
      <RightContent reportId={reportId} />
    </div>
  );
};

export const InvoiceReportDetail: FC<InvoiceReportDetailProps> = memo(
  (props) => {
    return (
      <SuspenseErrorBoundary>
        <InnerDetail {...props} />
      </SuspenseErrorBoundary>
    );
  }
);

InvoiceReportDetail.displayName = 'InvoiceReportDetail';
